/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { TransferStatusChangeDto } from '../models/transfer-status-change-dto';
import { WithdrawalCalculateFeeDto } from '../models/withdrawal-calculate-fee-dto';
import { WithdrawalConfirmationDto } from '../models/withdrawal-confirmation-dto';
import { WithdrawalConfirmationResultDto } from '../models/withdrawal-confirmation-result-dto';
import { WithdrawalMethodDto } from '../models/withdrawal-method-dto';
import { WithdrawalTemplateDto } from '../models/withdrawal-template-dto';

@Injectable({
  providedIn: 'root',
})
export class UserWithdrawalControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation updateTemplateUsingPut
   */
  static readonly UpdateTemplateUsingPutPath = '/frontend/user/withdrawals/template';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateTemplateUsingPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTemplateUsingPut$Response(params: {
    body: WithdrawalTemplateDto
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, UserWithdrawalControllerService.UpdateTemplateUsingPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateTemplateUsingPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTemplateUsingPut(params: {
    body: WithdrawalTemplateDto
  },
  context?: HttpContext

): Observable<void> {

    return this.updateTemplateUsingPut$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation saveTemplateUsingPost
   */
  static readonly SaveTemplateUsingPostPath = '/frontend/user/withdrawals/template';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `saveTemplateUsingPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  saveTemplateUsingPost$Response(params: {
    body: WithdrawalTemplateDto
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, UserWithdrawalControllerService.SaveTemplateUsingPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `saveTemplateUsingPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  saveTemplateUsingPost(params: {
    body: WithdrawalTemplateDto
  },
  context?: HttpContext

): Observable<void> {

    return this.saveTemplateUsingPost$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation getWithdrawalMethodUsingGet
   */
  static readonly GetWithdrawalMethodUsingGetPath = '/frontend/user/withdrawals/{currencyCode}/methods/{method}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getWithdrawalMethodUsingGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  getWithdrawalMethodUsingGet$Response(params: {
    currencyCode: string;
    method: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<WithdrawalMethodDto>> {

    const rb = new RequestBuilder(this.rootUrl, UserWithdrawalControllerService.GetWithdrawalMethodUsingGetPath, 'get');
    if (params) {
      rb.path('currencyCode', params.currencyCode, {});
      rb.path('method', params.method, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WithdrawalMethodDto>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getWithdrawalMethodUsingGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getWithdrawalMethodUsingGet(params: {
    currencyCode: string;
    method: string;
  },
  context?: HttpContext

): Observable<WithdrawalMethodDto> {

    return this.getWithdrawalMethodUsingGet$Response(params,context).pipe(
      map((r: StrictHttpResponse<WithdrawalMethodDto>) => r.body as WithdrawalMethodDto)
    );
  }

  /**
   * Path part for operation withdrawalConfirmationUsingPost
   */
  static readonly WithdrawalConfirmationUsingPostPath = '/frontend/user/withdrawals/{currencyCode}/methods/{method}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `withdrawalConfirmationUsingPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  withdrawalConfirmationUsingPost$Response(params: {
    currencyCode: string;
    method: string;
    body: WithdrawalConfirmationDto
  },
  context?: HttpContext

): Observable<StrictHttpResponse<WithdrawalConfirmationResultDto>> {

    const rb = new RequestBuilder(this.rootUrl, UserWithdrawalControllerService.WithdrawalConfirmationUsingPostPath, 'post');
    if (params) {
      rb.path('currencyCode', params.currencyCode, {});
      rb.path('method', params.method, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WithdrawalConfirmationResultDto>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `withdrawalConfirmationUsingPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  withdrawalConfirmationUsingPost(params: {
    currencyCode: string;
    method: string;
    body: WithdrawalConfirmationDto
  },
  context?: HttpContext

): Observable<WithdrawalConfirmationResultDto> {

    return this.withdrawalConfirmationUsingPost$Response(params,context).pipe(
      map((r: StrictHttpResponse<WithdrawalConfirmationResultDto>) => r.body as WithdrawalConfirmationResultDto)
    );
  }

  /**
   * Path part for operation calculateFeeUsingPost
   */
  static readonly CalculateFeeUsingPostPath = '/frontend/user/withdrawals/calculateFee';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calculateFeeUsingPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculateFeeUsingPost$Response(params: {
    body: WithdrawalCalculateFeeDto
  },
  context?: HttpContext

): Observable<StrictHttpResponse<WithdrawalCalculateFeeDto>> {

    const rb = new RequestBuilder(this.rootUrl, UserWithdrawalControllerService.CalculateFeeUsingPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WithdrawalCalculateFeeDto>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calculateFeeUsingPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculateFeeUsingPost(params: {
    body: WithdrawalCalculateFeeDto
  },
  context?: HttpContext

): Observable<WithdrawalCalculateFeeDto> {

    return this.calculateFeeUsingPost$Response(params,context).pipe(
      map((r: StrictHttpResponse<WithdrawalCalculateFeeDto>) => r.body as WithdrawalCalculateFeeDto)
    );
  }

  /**
   * Path part for operation getWithdrawalMethodsUsingGet
   */
  static readonly GetWithdrawalMethodsUsingGetPath = '/frontend/user/withdrawals/{currencyCode}/methods';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getWithdrawalMethodsUsingGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  getWithdrawalMethodsUsingGet$Response(params: {
    currencyCode: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Array<WithdrawalMethodDto>>> {

    const rb = new RequestBuilder(this.rootUrl, UserWithdrawalControllerService.GetWithdrawalMethodsUsingGetPath, 'get');
    if (params) {
      rb.path('currencyCode', params.currencyCode, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WithdrawalMethodDto>>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getWithdrawalMethodsUsingGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getWithdrawalMethodsUsingGet(params: {
    currencyCode: string;
  },
  context?: HttpContext

): Observable<Array<WithdrawalMethodDto>> {

    return this.getWithdrawalMethodsUsingGet$Response(params,context).pipe(
      map((r: StrictHttpResponse<Array<WithdrawalMethodDto>>) => r.body as Array<WithdrawalMethodDto>)
    );
  }

  /**
   * Path part for operation getTemplatesUsingGet
   */
  static readonly GetTemplatesUsingGetPath = '/frontend/user/withdrawals/{currencyCode}/methods/{method}/templates';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTemplatesUsingGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTemplatesUsingGet$Response(params: {
    currencyCode: string;
    method: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Array<WithdrawalTemplateDto>>> {

    const rb = new RequestBuilder(this.rootUrl, UserWithdrawalControllerService.GetTemplatesUsingGetPath, 'get');
    if (params) {
      rb.path('currencyCode', params.currencyCode, {});
      rb.path('method', params.method, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WithdrawalTemplateDto>>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTemplatesUsingGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTemplatesUsingGet(params: {
    currencyCode: string;
    method: string;
  },
  context?: HttpContext

): Observable<Array<WithdrawalTemplateDto>> {

    return this.getTemplatesUsingGet$Response(params,context).pipe(
      map((r: StrictHttpResponse<Array<WithdrawalTemplateDto>>) => r.body as Array<WithdrawalTemplateDto>)
    );
  }

  /**
   * Path part for operation getWithdrawalStateUsingGet
   */
  static readonly GetWithdrawalStateUsingGetPath = '/frontend/user/withdrawals/{currencyCode}/methods/{method}/state/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getWithdrawalStateUsingGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  getWithdrawalStateUsingGet$Response(params: {
    currencyCode: string;
    method: string;
    id: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<TransferStatusChangeDto>> {

    const rb = new RequestBuilder(this.rootUrl, UserWithdrawalControllerService.GetWithdrawalStateUsingGetPath, 'get');
    if (params) {
      rb.path('currencyCode', params.currencyCode, {});
      rb.path('method', params.method, {});
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TransferStatusChangeDto>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getWithdrawalStateUsingGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getWithdrawalStateUsingGet(params: {
    currencyCode: string;
    method: string;
    id: string;
  },
  context?: HttpContext

): Observable<TransferStatusChangeDto> {

    return this.getWithdrawalStateUsingGet$Response(params,context).pipe(
      map((r: StrictHttpResponse<TransferStatusChangeDto>) => r.body as TransferStatusChangeDto)
    );
  }

  /**
   * Path part for operation deleteTemplateUsingDelete
   */
  static readonly DeleteTemplateUsingDeletePath = '/frontend/user/withdrawals/template/{templateId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteTemplateUsingDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteTemplateUsingDelete$Response(params: {
    templateId: number;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, UserWithdrawalControllerService.DeleteTemplateUsingDeletePath, 'delete');
    if (params) {
      rb.path('templateId', params.templateId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteTemplateUsingDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteTemplateUsingDelete(params: {
    templateId: number;
  },
  context?: HttpContext

): Observable<void> {

    return this.deleteTemplateUsingDelete$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
